import React from 'react'

const Backend = () => {
  return (
    <div className="skills_content">
       <h3 className="skills_title"> Backend developer
        </h3> 

        <div className="skills_box">
          <div className="skills_group">
            <div className="skills_data">
            <i class='bx bx-badge-check'></i>  

            <div>
                <h3 className="skills_name">Java </h3>
                <span className="skills_level"> Advanced</span>
            </div>
            </div>

            <div className="skills_data">
            <i class='bx bx-badge-check'></i>  

            <div>
                <h3 className="skills_name">MySQL</h3>
                <span className="skills_level">Intermediate </span>
            </div>
            </div>
            
            <div className="skills_data">
            <i class='bx bx-badge-check'></i>  

            <div>
                <h3 className="skills_name">PostgreSQL</h3>
                <span className="skills_level"> Intermediate</span>
            </div>
            </div>

            <div className="skills_data">
            <i class='bx bx-badge-check'></i>  

            <div>
                <h3 className="skills_name">SpringBoot</h3>
                <span className="skills_level"> Intermediate</span>
            </div>
            </div>


            </div>  

            <div className="skills_group">
            <div className="skills_data">
            <i class='bx bx-badge-check'></i>  

            <div>
                <h3 className="skills_name">Hibernate </h3>
                <span className="skills_level"> Advanced</span>
            </div>
            </div>

            <div className="skills_data">
            <i class='bx bx-badge-check'></i>  

            <div>
                <h3 className="skills_name">JDBC</h3>
                <span className="skills_level">Intermediate </span>
            </div>
            </div>
            
            <div className="skills_data">
            <i class='bx bx-badge-check'></i>  

            <div>
                <h3 className="skills_name">REST API</h3>
                <span className="skills_level"> Intermediate</span>
            </div>
            </div>

            <div className="skills_data">
            <i class='bx bx-badge-check'></i>  

            <div>
                <h3 className="skills_name">Postman</h3>
                <span className="skills_level"> Intermediate</span>
            </div>
            </div>


            </div>  
        </div>
    </div>
  )
}

export default Backend
